import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {HierarchyMetadata} from '@wallaby-ui/core';
import {WallabyCoreSchema} from 'src/js/common/types';

import {MEDICATIONS_REDUCER_STATE_ID} from './medications_constants';

type MedicationAtcWithMetadata = WallabyCoreSchema.components['schemas']['AtcHierarchyNodeWithParentDto'] & HierarchyMetadata;
export interface MedicationsState {
  filterData: MedicationAtcWithMetadata[];
  isInitialized: boolean;
}

const initialState: MedicationsState = {
  filterData: [],
  isInitialized: false,
};

export interface AddFilterDataPayload {
  filterData: MedicationAtcWithMetadata[];
}

export const medicationsSlice = createSlice({
  name: MEDICATIONS_REDUCER_STATE_ID,
  initialState,
  reducers: {
    addFilterData: (state, action: PayloadAction<AddFilterDataPayload>) => {
      state.filterData = action.payload.filterData;
      state.isInitialized = true;
    },
  },
});
